import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { reRegisterSnapshot } from "./authAction";

const storage = firebase.storage();
const uploadFile = async (file, folder) => {
    if (file instanceof File) {
        const storageRef = storage.ref().child(`${folder}/${file.name}`);
        const uploadTask = await storageRef.put(file);
        return uploadTask.ref.getDownloadURL();
    }
    return null;
};

export const createMomentosAction =
    (uid, payload, onSuccess = () => {}) =>
    async (dispatch) => {
        const myMomentosData = [];
        dispatch(Loader(true));
        try {
            firebase
                .firestore()
                .collection("momentos")
                .where("athlete_id", "==", uid)
                .onSnapshot((query) => {
                    for (let doc of query.docs) {
                        if (doc.exists) {
                            myMomentosData.push({ id: doc.id, ...doc.data() });
                        }
                    }
                });
            const { momento, qrCodes } = payload;
            const updatedMomento = await Promise.all(
                momento.map(async (item) => {
                    const mediaDownloadURL = await uploadFile(
                        item.media,
                        "momentos"
                    );
                    item.media = mediaDownloadURL || item.media;

                    return item;
                })
            );
            const updatedQrCodes = await Promise.all(
                qrCodes.map(async (qrCode) => {
                    if (qrCode instanceof File) {
                        const qrCodeDownloadURL = await uploadFile(
                            qrCode,
                            "QRCode"
                        );
                        return qrCodeDownloadURL || qrCode;
                    }
                    return qrCode;
                })
            );
            await firebase
                .firestore()
                .collection("momentos")
                .add({
                    ...payload,
                    private: false,
                    isDeleted: false,
                    createdAt: firebase.firestore.Timestamp.now(),
                    momento: updatedMomento,
                    managerRating: false,
                    qrCodes: updatedQrCodes,
                    momentoID: `${payload?.athleteID}-M${
                        myMomentosData.length + 1 < 10
                            ? `00${myMomentosData.length + 1}`
                            : myMomentosData.length + 1 < 100
                            ? `0${myMomentosData.length + 1}`
                            : myMomentosData.length + 1
                    }`,
                })
                .then(
                    firebase
                        .firestore()
                        .collection("users")
                        .doc(payload.athlete_id)
                        .update({
                            momentoCount:
                                firebase.firestore.FieldValue.increment(1),
                        })
                )
                .then(dispatch(reRegisterSnapshot(payload.athlete_id)));

            dispatch(Loader(false));
            onSuccess();
        } catch (error) {
            dispatch(Loader(false));
            console.error("Error creating momentos:", error);
        }
    };
export const isManagerExist =
    (email, onComplete = () => {}) =>
    (dispatch) => {
        firebase
            .firestore()
            .collection("users")
            .where("email", "==", email)
            .get()
            .then((query) => {
                if (query.docs.length > 0) {
                    if (query?.docs[0].data().role == "fan") {
                        onComplete();
                    } else {
                        toast.error("Manager email should b fan");
                    }
                } else {
                    toast.error(
                        "This manager email not exist in over platform"
                    );
                }
            });
    };
export const getAthleteMomentos = (uid) => async (dispatch) => {
    dispatch(Loader(true));
    try {
        firebase
            .firestore()
            .collection("momentos")
            .where("athlete_id", "==", uid)
            .where("isDeleted", "==", false)
            .orderBy("createdAt", "desc")
            .limit(5)
            .onSnapshot((query) => {
                const myMomentos = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        myMomentos.push({ id: doc.id, ...doc.data() });
                    }
                }
                dispatch(Loader(false));
                dispatch({
                    type: "MY_MOMENTOS",
                    payload: myMomentos,
                });
            });
    } catch (error) {
        dispatch(Loader(false));
        console.error("Error listening to momentos:", error);
    }
};
export const getMoreAthleteMomentos =
    (uid, lastItem, onError = () => {}, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            firebase
                .firestore()
                .collection("momentos")
                .where("athlete_id", "==", uid)
                .where("isDeleted", "==", false)
                .orderBy("createdAt", "desc")
                .limit(5)
                .startAfter(lastItem.createdAt)
                .onSnapshot((query) => {
                    const moreMomentos = [];
                    for (let doc of query.docs) {
                        if (doc.exists) {
                            moreMomentos.push({ id: doc.id, ...doc.data() });
                        }
                    }
                    if (moreMomentos.length === 0) {
                        onError();
                    }
                    dispatch({
                        type: "MY_MOMENTOS_MORE",
                        payload: moreMomentos,
                    });
                    onSuccess();
                });
        } catch (error) {
            toast.error("error", error);
        }
    };

export const getSingleMomento = (id) => async (dispatch) => {
    firebase
        .firestore()
        .collection("momentos")
        .doc(id)
        .get()
        .then((doc) => {
            dispatch({
                type: "SINGLE_MOMENTO",
                payload: { id: doc.id, ...doc.data() },
            });
        });
};
export const deleteMomento =
    (id, uid, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("momentos")
                .doc(id)
                .update({
                    isDeleted: true,
                })
                .then
                // firebase
                //     .firestore()
                //     .collection("users")
                //     .doc(uid)
                //     .update({
                //         momentoCount:
                //             firebase.firestore.FieldValue.increment(-1),
                //     })
                ();
            onSuccess();
        } catch (error) {
            console.error("Error deleting momento:", error);
        }
    };

export const updateMomentoStatus =
    (id, val, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            firebase
                .firestore()
                .collection("momentos")
                .doc(id)
                .update({ private: val })
                .then(onSuccess());
        } catch (error) {
            console.error("Error listening to momentos:", error);
        }
    };

export const updateMomento =
    (
        ID,
        payload,
        //  mediaToRemove, QRMediaRemove,
        onSuccess = () => {}
    ) =>
    async (dispatch) => {
        dispatch(Loader(true));
        try {
            // mediaToRemove?.map(async (url) => {
            //     try {
            //         await firebase.storage().refFromURL(url).delete();
            //     } catch (error) {
            //         dispatch(Loader(false));
            //         console.error(
            //             `Error deleting media file at URL ${url}:`,
            //             error
            //         );
            //     }
            // });
            // QRMediaRemove?.map(async (url) => {
            //     try {
            //         await firebase.storage().refFromURL(url).delete();
            //     } catch (error) {
            //         dispatch(Loader(false));
            //         console.error(
            //             `Error deleting QR media file at URL ${url}:`,
            //             error
            //         );
            //     }
            // });

            const { momento, qrCodes } = payload;
            // const storage = firebase.storage();
            // const uploadFile = async (file, folder) => {
            //     if (file instanceof File) {
            //         const storageRef = storage
            //             .ref()
            //             .child(`${folder}/${file.name}`);
            //         const uploadTask = await storageRef.put(file);
            //         return uploadTask.ref.getDownloadURL();
            //     }
            //     return file;
            // };

            const updatedMomento = await Promise.all(
                momento.map(async (item) => {
                    const mediaDownloadURL = await uploadFile(
                        item.media,
                        "momentos"
                    );
                    item.media = mediaDownloadURL || item.media;

                    return item;
                })
            );
            const updatedQrCodes = await Promise.all(
                qrCodes.map(async (qrCode) => {
                    if (qrCode instanceof File) {
                        const qrCodeDownloadURL = await uploadFile(
                            qrCode,
                            "QRCode"
                        );
                        return qrCodeDownloadURL || qrCode;
                    }
                    return qrCode;
                })
            );

            await firebase
                .firestore()
                .collection("momentos")
                .doc(ID)
                .update({
                    ...payload,
                    momento: updatedMomento,
                    qrCodes: updatedQrCodes,
                })
                .then(dispatch(Loader(false)), onSuccess());
        } catch (error) {
            dispatch(Loader(false));
            console.error("An error occurred during update:", error);
        }
    };

export const momentoPrivatePurchase =
    (payload, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            firebase
                .firestore()
                .collection("momento_private_purchases")
                .add({
                    ...payload,
                    createdAt: firebase.firestore.Timestamp.now(),
                })
                .then(onSuccess());
        } catch (error) {
            toast.error("error:", error);
        }
    };
// Memento Requests

export const getMomentoRequests = (id) => async (dispatch) => {
    try {
        dispatch(Loader(true));
        await firebase
            .firestore()
            .collection("momento_requests")
            .where("athlete_id", "==", id)
            .onSnapshot((query) => {
                let momnentoRequests = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        momnentoRequests.push({ id: doc.id, ...doc.data() });
                    }
                }
                dispatch({
                    type: "MOMENTOS_REQUESTS",
                    payload: momnentoRequests,
                });
                dispatch(Loader(false));
            });
    } catch (error) {
        dispatch(Loader(false));
        console.error("Error listening to momentos:", error);
    }
};
export const acceptMomentoReuest =
    (id, val, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("momento_requests")
                .doc(id)
                .update({
                    status: val,
                });
            onSuccess();
        } catch (error) {
            console.error("Error listening to momentos:", error);
        }
    };

export const submitQrRequest =
    (payload, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("momentoQrRequests")
                .add({
                    ...payload,
                    status: "pending",
                    createdAt: firebase.firestore.Timestamp.now(),
                })
                .then(onSuccess());
        } catch (error) {
            toast.error(error);
        }
    };

export const getQrRequest =
    (id, onSuccess = (res) => {}) =>
    async (dispatch) => {
        dispatch(Loader(true));
        try {
            await firebase
                .firestore()
                .collection("momentoQrRequests")
                .doc(id)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        onSuccess(doc.data());
                        dispatch(Loader(false));
                    } else {
                        dispatch(Loader(false));
                        toast.error("No Request Against this ID Exists");
                    }
                    dispatch(Loader(false));
                });
        } catch (error) {
            dispatch(Loader(false));
            toast.error(error);
        }
    };

export const submitQrCode =
    (id, payload, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            const mediaDownloadURL = await uploadFile(
                payload?.url,
                "momentoFamilyQrCodes"
            );
            payload.url = await mediaDownloadURL;
            await firebase
                .firestore()
                .collection("momentoFamilyQrCodes")
                .add({
                    ...payload,
                    createdAt: firebase.firestore.Timestamp.now(),
                })
                .then(
                    await firebase
                        .firestore()
                        .collection("momentoQrRequests")
                        .doc(id)
                        .delete()
                        .then(onSuccess())
                );
        } catch (error) {
            toast.error(error);
        }
    };

export const getFamilyQrCodes = (id) => async (dispatch) => {
    dispatch(Loader(true));
    try {
        await firebase
            .firestore()
            .collection("momentoFamilyQrCodes")
            .where("userId", "==", id)
            .onSnapshot((query) => {
                const submittedQRCodes = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        submittedQRCodes.push({ id: doc.id, ...doc.data() });
                    }
                }

                dispatch({
                    type: "FAMILY_QR_CODES",
                    payload: submittedQRCodes,
                });
                dispatch(Loader(false));
            });
    } catch (error) {
        dispatch(Loader(false));
        toast.error(error);
    }
};

export const getDashboardStats = (ID) => async (dispatch) => {
    dispatch(Loader(true));
    try {
        await firebase
            .firestore()
            .collection("momento_dashboard_stats")
            .where("athleteID", "==", ID)
            .get()
            .then((query) => {
                for (let doc of query.docs) {
                    if (doc.exists) {
                        let data = doc.data();
                        dispatch({
                            type: "DASHBOARD_STATS",
                            payload: data,
                        });
                    }
                }
            });
        dispatch(Loader(false));
    } catch (error) {
        dispatch(Loader(false));
        toast.error(error);
    }
};
export const getPendingRequests = (ID) => async (dispatch) => {
    try {
        await firebase
            .firestore()
            .collection("momento_requests")
            .where("athlete_id", "==", ID)
            .where("status", "==", "pending")
            .onSnapshot((query) => {
                let requestLength = 0;
                for (let doc of query.docs) {
                    if (doc.exists) {
                        requestLength++;
                    }
                }
                dispatch({
                    type: "PENDING_REQUESTS",
                    payload: requestLength,
                });
            });
    } catch (error) {
        toast.error(error);
    }
};
export const checkBoughtMomentos =
    (uid, ID, onSuccess = () => {}, onError = () => {}) =>
    async (dispatch) => {
        await firebase
            .firestore()
            .collection("momento_purchases")
            .where("momentoId", "==", ID)
            .where("fan_id", "==", uid)
            .get()
            .then((query) => {
                let documents = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        documents.push({ id: doc.id, ...doc.data() });
                    }
                }
                if (documents.length > 0) {
                    onError();
                } else {
                    onSuccess();
                }
            });
    };

const Loader = (data) => async (dispatch) => {
    dispatch({
        type: "MOMENTO_LOADER",
        payload: data,
    });
};
export const updateRatingData =
    (ratingData, docId, onComplete = () => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("momentos")
                .doc(docId)
                .update(ratingData);
            dispatch({
                type: "ADD_MANAGER_RATING",
                payload: docId,
            });
            onComplete();
        } catch (error) {
            console.error("Error updating rating data: ", error);
        }
    };
export const addStrategyRating = (data) => () => {
    firebase.firestore().collection("strategy-rating").add(data);
};
